import { useEffect, useState } from "react";
import useAuthStore from "../stores/authStore";

export default function SecurityOverlay() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const [visible, setVisible] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;

    const handle = () => {
      if (document.hidden) {
        setFading(false);
        setVisible(true);
      } else {
        setFading(true);
        setTimeout(() => {
          setVisible(false);
          setFading(false);
        }, 400);
      }
    };

    document.addEventListener("visibilitychange", handle);
    return () => document.removeEventListener("visibilitychange", handle);
  }, [isAuthenticated]);

  if (!isAuthenticated || !visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        opacity: fading ? 0 : 1,
        transition: fading ? "opacity 0.4s ease" : "none",
      }}
    >
      <div
        style={{
          width: "64px",
          height: "64px",
          borderRadius: "16px",
          background: "#158d38",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "32px",
          fontWeight: "800",
          color: "#d0db97",
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        B
      </div>
      <p
        style={{
          fontSize: "20px",
          fontWeight: "700",
          color: "#181d27",
          fontFamily: "'DM Sans', sans-serif",
          margin: 0,
        }}
      >
        Balshee
      </p>
      <p
        style={{
          fontSize: "14px",
          color: "#9aaa9a",
          fontFamily: "'DM Sans', sans-serif",
          margin: 0,
        }}
      >
        Données protégées
      </p>
    </div>
  );
}
